/**
 * Pricelists in centra have a name, id, currency formatting information and
 * a list over which country codes are allowed to use it
 */
export default {
  namespaced: true,
  state () {
    return {
      pricelists: [] // Should contains all pricelists
    }
  },
  mutations: {
    pricelists (state, pricelists) {
      state.pricelists = pricelists
    }
  },
  actions: {
    /**
     * Stores all pricelists in the state
     */
    lookupPricelists ({ state, commit, rootState }) {
      return this.$backendApi.get('/pricelists').then((response) => {
        commit('pricelists', response.data)
      })
    }
  },
  getters: {
    /**
     * As it says, all pricelists or no pricelists
     */
    getPricelists (state, getters, rootState) {
      return state.pricelists
    }
  }
}
